import Vue from 'vue'
import Router from 'vue-router'
import { auth, onAuthStateChanged } from '@/datasources/firebase'

Vue.use(Router)

const Login = () => import('./components/Login.vue')
const Home = () => import('./components/Home.vue')
const Gallery = () => import('./components/camera_gallery/CameraGallery.vue')
const CameraPage = () => import('./components/camera_gallery/CameraPage.vue')
const InfoPage = () => import('./components/camera_gallery/InfoPage.vue')
const PostPage = () => import('./components/camera_gallery/PostPage.vue')
const ToDoPage = () => import('./components/to_do/ToDo.vue')
const ToDoOriginPage = () => import('./components/to_do/ToDoOrigin.vue')
const OfflinePage = () => import('./components/offline/OfflinePage.vue')
const SubscribePage = () => import('./components/notification/SubscribePage.vue')
const PushPage = () => import('./components/notification/PushPage.vue')
const Kiosk = () => import('./components/order/Kiosk.vue')
const Calcs = () => import('./components/manage/Calc.vue')
const QRCode = () => import('./components/manage/QR.vue')



const checkAuthState = () =>
  new Promise((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe();
      resolve(user);
    });
  });

const requireAuth = async (to, from, next) => {
  // 온라인 상태면 파이어베이스로 직접 확인, 오프라인이면 현재 사용자로 확인
  const user = navigator.onLine ? await checkAuthState() : auth.currentUser;
  if (user) {
    console.log('User auth is valid.');
    next();
  } else {
    console.log("User auth isn't valid. Move to LoginPage.");
    next('/login');
  }
};

const routes = [
  {
    path: '/login',
    name: 'Login',
    title: 'Login',
    component: Login,
  },
  {
    path: '/',
    name: 'Home',
    title: 'Home',
    menu: true,
    component: Home,
    beforeEnter: requireAuth
  },
  {
    path: '/calc',
    name: 'Clac',
    title: '정산기',
    menu: true,
    component: Calcs,
    // beforeEnter: requireAuth
  },
  {
    path: '/kiosk',
    name: 'Kiosk',
    title: '키오스크',
    menu: true,
    component: Kiosk,
    // beforeEnter: requireAuth
  },
  {
    path: '/qr',
    name: 'QRCode',
    title: 'QR',
    menu: true,
    component: QRCode,
    beforeEnter: requireAuth
  },
  {
    path: '/gallery',
    name: 'Gallery',
    title: '사진 갤러리',
    menu: true,
    component: Gallery,
    beforeEnter: requireAuth
  },
  {
    path: '/camera',
    name: 'CameraPage',
    title: '사진 촬영',
    component: CameraPage,
    beforeEnter: requireAuth
  },
  {
    path: '/info',
    name: 'InfoPage',
    title: '설명',
    component: InfoPage,
    beforeEnter: requireAuth
  },
  {
    path: '/post',
    name: 'PostPage',
    title: '업로드 페이지',
    component: PostPage,
    beforeEnter: requireAuth
  },
  {
    path: '/todo',
    name: 'ToDoPage',
    title: 'TO-DO 리스트',
    menu: true,
    component: ToDoPage,
    beforeEnter: requireAuth
  },
  {
    path: '/todoOrigin',
    name: 'ToDoOriginPage',
    title: 'TO-DO 오리지널(미사용)',
    menu: true,
    component: ToDoOriginPage,
    beforeEnter: requireAuth
  },
  {
    path: '/offline',
    name: 'OfflinePage',
    title: '오프라인 테스트',
    menu: true,
    component: OfflinePage,
    beforeEnter: requireAuth
  },
  {
    path: '/subscribe',
    name: 'SubscribePage',
    title: '알림 구독/해제',
    menu: true,
    component: SubscribePage,
    beforeEnter: requireAuth
  },
  {
    path: '/push',
    name: 'PushPage',
    title: '푸시 전송',
    menu: true,
    component: PushPage,
    beforeEnter: requireAuth
  },
  {
    path: '*',
    name: 'Home',
    title: 'Home',
    component: Home,
    beforeEnter: requireAuth
  },
]

export const menuList = routes
  .filter(info => info.menu)
  .map(info => {
    return {
      title: info.title || info.name,
      path: info.path
    }
  })

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes
})
